import { observable, action } from 'mobx';

// 调试模式
export const MODE = {
  EXPERT: 'expert', // 专家模式
  NORMAL: 'normal', // 一般模式
  AUTO: 'automatic', // 自动模式
  DETECT: 'detect'
};

export default class StepStore {
  @observable step = 1;

  @observable mode = MODE.NORMAL;

  @observable allLoad = false;

  @action next() {
    return new Promise((resolve) => {
      setTimeout(() => {
        this.step += 1;
        resolve();
      }, 1000);
    });
  }
}

export const stepStore = new StepStore();
